import { Component } from '@angular/core';

@Component({
    selector: 'app-main-modal',
    templateUrl: './main-modal.component.html',
    standalone: false
})
export class MainModalComponent {
  constructor() {}
}
